module.exports = __webpack_public_path__ + "static/media/completed.03111fdb.png";